import { DepartmentResource } from '@/entities/Department/Department'
import { createUnknownErrorResult } from '@/entities/FetchResult'
import { FetchCollectionResult, FetchResultType } from '@/entities/FetchResult'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { reportError, reportMessage } from '@/helpers/errorReporting'
import { generateApiUrl } from '@/helpers/url'
import { getIncluded } from '@/japi/getIncluded'
import { isResourceCollectionDocument } from '@/japi/guards/isResourceCollectionDocument'
import { JapiDocument } from '@/japi/types/Document'

import { Setting, SettingResource } from './Setting'
import { transformSetting } from './SettingTransformers'

export const getSettingsApiCall = async (): Promise<FetchCollectionResult<Setting[], string>> => {
    try {
        const includes = ['department']

        const url = generateApiUrl({
            endpoint: '/api/v2/settings',
            queryParams: {
                include: includes.join(','),
            },
        })

        const response = await authorizedFetch(url, { method: 'GET' })

        const doc: JapiDocument = await response.json()

        if (! isResourceCollectionDocument<SettingResource>(doc) || ! doc.data) {
            reportMessage('getSettingsApiCall', `getSettingsApiCall failed with status code ${response.status}`)

            return createUnknownErrorResult(response.status)
        }

        const settings = doc.data.map(settingResource => {
            const departmentResource = getIncluded<DepartmentResource>(doc, settingResource, 'department')

            return transformSetting(settingResource, departmentResource?.id)
        })

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: settings,
        }
    } catch (error) {
        reportError('getSettingsApiCall', error)

        return createUnknownErrorResult(500)
    }
}
